import { IPublicClientApplication } from '@azure/msal-browser';
import { CustomerReference } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { createCustomerReference, deleteCustomerReference, updateCustomerReference } from './index';

export const createNominationCustomerReferencesApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  createCustomerReference: (instance: IPublicClientApplication, nominationId: number, customerReference: CustomerReference) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => createCustomerReference(fetchContext, nominationId, customerReference, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('createCustomerReference', isInFlight);
    },
  ),
  updateCustomerReference: (instance: IPublicClientApplication, customerReference: CustomerReference) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateCustomerReference(fetchContext, customerReference, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateCustomerReference', isInFlight);
    },
  ),
  deleteCustomerReference: (instance: IPublicClientApplication, customerReferenceId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => deleteCustomerReference(fetchContext, customerReferenceId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('deleteCustomerReference', isInFlight);
    },
  ),
});
